module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-15.87c78101.png";